import { Attributes } from '@leverege/ui-attributes';
import Types from "../../constants/Types.js";
export default {
  name: 'name',
  objectType: Types.firmwareApplication,
  valueType: 'string',
  get: (data, cxt) => {
    if (!data || !Attributes.get('deviceTypeId', Types.firmwareApplication, data)) {
      return null;
    }
    const deviceType = Attributes.getAttribute('deviceType', Types.firmwareApplication);
    const deviceTypeVal = deviceType.get(data);
    if (!deviceTypeVal) {
      deviceType.load(data);
    }
    return `${Attributes.get('deviceType$name', Types.firmwareApplication, data)} ${Attributes.get('version', Types.firmwareApplication, data)}`;
  },
  displayName: 'Name',
  source: {
    type: Types.apiName,
    editable: false,
    creatable: false
  }
};